module.exports = __webpack_public_path__ + "img/input-bg.a4a87268.png";